import React, { createContext, ReactNode, useMemo } from 'react';
import type { ValueOf } from 'type-fest';

import { TriggerContext } from 'components/Settings/Billing/types';

type OrganizationContextType = {
  organizationId: number | undefined;
  triggerContext: ValueOf<typeof TriggerContext>;
};

export const OrganizationContext = createContext<OrganizationContextType>({
  organizationId: undefined,
  triggerContext: TriggerContext.ProDashboard,
});

const OrganizationContextProvider = ({
  children,
  organizationId,
  triggerContext,
}: {
  children: ReactNode;
  organizationId: number | undefined;
  triggerContext: ValueOf<typeof TriggerContext>;
}) => {
  const contextValues = useMemo(() => ({ organizationId, triggerContext }), [organizationId, triggerContext]);

  return <OrganizationContext.Provider value={contextValues}>{children}</OrganizationContext.Provider>;
};

export default OrganizationContextProvider;
